import React, { useEffect, useState, useRef } from "react";
import { getBankLabel, capitalizeFullName } from '../../utils/Utils'


import { ReactComponent as Down } from '../../assets/IconsColurs/IconsGeneral/chevronDown.svg';
import { ReactComponent as Up } from '../../assets/IconsColurs/IconsGeneral/chevronUp.svg';

const InputSelectMethod = ({ data, handleAccountCreate, setBank, bank }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Referencias
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);

    const handleToggleDropdown = () => {
        // Togglear manualmente
        setIsOpen((prev) => !prev);
    };

    const handleOptionClick = (option) => {
        setBank(option);
        setIsOpen(false);
    };

    const handleAddBankAccount = () => {
        handleAccountCreate();
    };

    useEffect(() => {
        if (isOpen && dropdownRef.current) {
            dropdownRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        }
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Si el clic NO está dentro del dropdown
            // Y el clic NO está dentro del botón, entonces cierra
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    let displayText = "Agrega una cuenta bancaria";
    if (bank) {
        if (bank.payment_method === 'PAYPAL' || bank.payment_method === 'VENMO') {
            displayText = bank.account_number;
        } else if (bank.payment_method === 'ACH') {
            const accountTypeLabel = bank.account_type === 'SAVINGS' ? 'Ahorros' : 'Corriente';
            displayText = `${bank.account_holder_name} - ${accountTypeLabel} *${bank.account_number.slice(-4)}`;
        } else { // Fallback for COP
            const accountTypeLabel = bank.account_type === 1 ? 'Ahorros' : 'Corriente';
            displayText = `${bank.account_holder_name} - ${getBankLabel(bank.bank_name)} ${accountTypeLabel} *${bank.account_number.slice(-4)}`;
        }
    }

    return (
        <div className="relative w-full">
            {/* Botón que simula el select (ahora con ref) */}
            <button
                ref={buttonRef}
                type="button"
                onClick={handleToggleDropdown}
                className="flex items-center justify-between bg-[#2B2B33] text-white py-2 px-3 rounded-md h-12 w-full"
            >
                <div className="mr-2">
                    <i className="fa fa-bank" aria-hidden="true" />
                </div>
                <span className="flex-1 mr-2 text-left overflow-hidden text-ellipsis whitespace-nowrap">{displayText}</span>
                <div className="text-xs">{isOpen ? <Up className="h-5 w-5 group-hover:text-black" alt="cripto wallet" /> : <Down className="h-5 w-5 group-hover:text-black" alt="cripto wallet" />}</div>
            </button>

            {/* Dropdown */}
            {isOpen && (
                <div
                    ref={dropdownRef}
                    className="absolute top-full left-0 mt-1 w-full bg-[#2B2B33] shadow-lg rounded-md py-1 z-50 max-h-60 overflow-y-auto"
                >
                    {data && data.length > 0 ? (
                        data.map((option, index) => {
                            let title = capitalizeFullName(option.account_holder_name);
                            let subtitle = '';

                            if (option.payment_method === 'PAYPAL' || option.payment_method === 'VENMO') {
                                title = option.account_number;
                                subtitle = null;
                            } else if (option.payment_method === 'ACH') {
                                const accountTypeLabel = option.account_type === 'SAVINGS' ? 'Ahorros' : 'Corriente';
                                subtitle = `${accountTypeLabel} *${option.account_number.slice(-4)}`;
                            } else { // COP
                                const accountTypeLabel = option.account_type === 0 ? 'Ahorros' : 'Corriente';
                                subtitle = `${getBankLabel(option.bank_name)} ${accountTypeLabel} *${option.account_number.slice(-4)}`;
                            }

                            return (
                                <div
                                    key={index}
                                    className="py-2 px-3 hover:bg-[#33333b] text-white cursor-pointer"
                                    onClick={() => handleOptionClick(option)}
                                >
                                    <p className="text-left text-sm font-medium">{title}</p>
                                    {subtitle && <p className="text-left text-xs text-gray-300">{subtitle}</p>}
                                </div>
                            );
                        })
                    ) : (
                        <div className="py-2 px-3 text-white">
                            No tengo cuentas de banco
                        </div>
                    )}

                    {/* Botón para agregar cuenta */}
                    <div
                        className="py-2 px-3 hover:bg-[#33333b] text-white cursor-pointer border-t border-[#33333b]"
                        onClick={handleAddBankAccount}
                    >
                        Agrega una cuenta bancaria
                    </div>
                </div>
            )}
        </div>
    );
};

export default InputSelectMethod;
